<!-- <app-doctors-next-select-departments [role]="selected.role"></app-doctors-next-select-departments> -->
<div id="content-wrapper" class="d-flex flex-column ml-0" *ngIf="true">
  <!-- Main Content -->
  <div id="content">
    <div class="container-fluid">
      <div class="row logo">
        <div class="col-12 row no-gutters justify-content-center">
          <h1 class="d-flex justify-content-center" style="flex-direction: column; align-items: center">
            <img src="/assets/doctors-next/Logo.png" alt="Doctors Next" />
          </h1>
        </div>
      </div>
      <!--  -->
      <div class="row justify-content-center" style="letter-spacing: 0;">
        <div class="col-12" id="main" >
          <p style="text-align: center; margin-top: 15px; width: 100%">
            職種・専門情報の入力
          </p>

          <form (submit)="_register" class="col-12 mx-auto center-block mt-5">
            <!-- 職種 -->
            <div class="row">
              <div class="col-md-12 text-left">
                <label class="col-form-label mb-0 py-0 text-caption">職種</label>
                <div class="row content-block">
                  <div *ngFor="let role of registerStateService.roles" class="col-md-6 mt-2">
                    <div style="text-align: left;">
                      <app-doctors-next-radio-button (click)="onRoleChange(role.key)" [value]="role.key "
                        [label]="role.label" [checked]="role.key === selected.role"></app-doctors-next-radio-button>
                    </div>
                  </div>
                  <div class="col-md-6 mt-2"></div>
                  <div class="col-md-6 mt-2">
                    <div style="text-align: left;">
                      <app-doctors-next-radio-button (click)="onRoleChange('others')" [value]="'others'"
                        [label]="'その他医療従事者'" [checked]="'others' === selected.role"></app-doctors-next-radio-button>
                    </div>
                  </div>
                  <div class="col-md-12 mt-3">
                    <div class="form-group">
                      <input style="width: 100%;" [disabled]="selected.role !== 'others'" type="text"
                        class="form-control" id="othersDescription" name="othersDescription" placeholder="詳細をご記入ください"
                        [(ngModel)]="selected.othersDescription">
                    </div>
                  </div>

                </div>


              </div>
            </div>
            <ng-container *ngIf="selected.role">
              <!-- 医師免許資格取得年 -->
              <div class="row" *ngIf="isShowLicenseYearForm">
                <div class="col-md-12 text-left">
                  <label class="col-form-label mb-0 py-0 text-caption">医師免許資格取得年</label>
                  <div class="row content-block">
                    <select class="form-control col-3 mr-3" test-id="year" name="year" id="licenseAcquisitionYear"
                      [(ngModel)]="selected.licenseAcquisitionYear">
                      <option [value]="year" *ngFor="let year of years">{{year}}</option>
                    </select>
                    <p>年</p>
                  </div>
                </div>
              </div>

              <!-- 診療科・専門 -->
              <div class="row" *ngIf="hasSpecialities">
                <div class="col-md-12 text-left">
                  <label class="col-form-label mb-0 py-0 text-caption">{{departmentLabel}}</label>

                  <div class="row content-block">
                    <div class="col-md-12">
                      <div class="row mb-2">{{selectedDepartmentsLabel}}</div>
                      <div class="row">
                        <div>
                          <app-doctors-next-button label="選択する" type="outline"
                            (click)="click($event)"></app-doctors-next-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- お勤め先の業種 -->
              <div class="row">
                <div class="col-md-12 text-left">
                  <label class="col-form-label mb-0 py-0 text-caption">お勤め先の業種</label>
                  <div class="row content-block">

                    <div *ngFor="let industryType of industryTypes" class="col-md-6 mt-2">
                      <div style="text-align: left;">
                        <app-doctors-next-radio-button (click)="selected.industryType = industryType"
                          [value]="industryType" [label]="industryType"
                          [checked]="industryType === selected.industryType"></app-doctors-next-radio-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 所属医療機関名 / 勤務先名 -->
              <div class="row">
                <div class="col-md-12 text-left">
                  <label class="col-form-label mb-0 py-0 text-caption">所属医療機関名 / 勤務先名</label>

                  <div class="row content-block">

                    <div class="form-group col-md-12">
                      <input type="text" class="form-control" style="width: 100%" id="affiliation" name="affiliation"
                        placeholder="" [(ngModel)]="selected.affiliation" />
                    </div>
                  </div>
                </div>
              </div>


              <!-- 勤務地 -->
              <div class="row">
                <div class="col-12 text-left">
                  <label class="col-form-label mb-0 py-0 text-caption">勤務地</label>
                  <div class="row content-block">

                    <div class="form-group col-12">
                      <div class="row mb-2">
                        <label class="col-md-3 col-6" for="pref">都道府県</label>
                        <!-- <input type="text" class="form-control" id="pref" name="pref" placeholder=""
                      [(ngModel)]="selected.affiliation" /> -->
                        <select class="form-control col-md-3 col-6" id="pref" name="pref" [(ngModel)]="selected.pref">
                          <option [value]="pref" *ngFor="let pref of prefecutures">{{pref}}</option>
                        </select>
                      </div>
                      <div class="row mb-2">
                        <label class="col-md-3 col-6" for="address">市区町村番地</label>
                        <input type="text" class="form-control col-md-9 col-6" id="address" name="address"
                          placeholder="任意でご入力してください" [(ngModel)]="selected.address" />
                      </div>
                      <div class="row">
                        <label class="col-md-3 col-6" for="building">建物名・号室</label>
                        <input type="text" class="form-control col-md-9 col-6" id="building" name="building"
                          placeholder="任意でご入力してください" [(ngModel)]="selected.building" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- お勤め先での役職 -->
              <div class="row">
                <div class="col-md-12 text-left">
                  <label class="col-form-label mb-0 py-0 text-caption">お勤め先での役職</label>
                  <div class="row content-block">

                    <div *ngFor="let position of positions" class="col-md-6 mt-2">
                      <div style="text-align: left;">
                        <app-doctors-next-radio-button (click)="selected.position = position" [value]="position"
                          [label]="position" [checked]="position === selected.position"></app-doctors-next-radio-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-center">
                  <button type="button" class="btn mb-4" [disabled]="!isSubmittable" (click)="_submit()">次へ</button>
                </div>
              </div>
            </ng-container>

            <!--  -->
            <div class="row">
              <div class="col-md-12 text-center">
                <a (click)="_back()" style="cursor: pointer">戻る</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>